import { render, staticRenderFns } from "./TileGridWidgetBannerTile.vue?vue&type=template&id=b4cf9902&scoped=true"
import script from "./TileGridWidgetBannerTile.vue?vue&type=script&setup=true&lang=ts"
export * from "./TileGridWidgetBannerTile.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TileGridWidgetBannerTile.vue?vue&type=style&index=0&id=b4cf9902&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cf9902",
  null
  
)

export default component.exports